import React from "react";
import { css } from "@emotion/react";
import { useSearchParams } from "react-router-dom";
interface ServiceNoticeTabProps {
    userType: "taker" | "user";
    serviceType: number;
}

const tabs = [
    { name: "경매대행", value: 1 },
    { name: "매물컨설팅", value: 3 },
    { name: "매수신청\n대리", value: 2 },
    { name: "임장동행", value: 4 },
    // { name: "미납관리비", value: 4 },
];
const ServiceNoticeTab = ({ userType, serviceType }: ServiceNoticeTabProps) => {
    const [searchParams, setSearchParams] = useSearchParams();

    const handleTabClick = (value: number) => {
        setSearchParams({
            ...Object.fromEntries(searchParams.entries()),
            serviceType: value.toString(),
        });
    };

    return (
        <div css={tabContainerStyle}>
            {tabs.map((tab) => (
                <div key={tab.value} css={tabStyle(tab.value == serviceType)} onClick={() => handleTabClick(tab.value)}>
                    {tab.name}
                    {tab.value !== 2 && <br />}
                    {userType == "taker" ? "등록" : ""}
                </div>
            ))}
        </div>
    );
};

export default ServiceNoticeTab;

const tabContainerStyle = css`
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 10px 14px;
    gap: 4px;
    border-bottom: 8px solid #efefef;
`;

const tabStyle = (isActive: boolean) => css`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    min-height: 54px;
    text-align: center;
    background-color: #c9c9c9;
    color: #fff;
    font-weight: bold;
    border-radius: 14px;
    border: 1px solid #f0f0f0;
    font-size: 15px;
    padding: 10px 0;
    white-space: pre-wrap;
    ${isActive &&
    css`
        background-color: #0047ff;
    `}
`;
